import { baseUrl, jwtHeaders, logoutUtil } from '../common/data';

// accepts either a ready string ("?page=1&limit=20") or an object ({ page: 1, limit: 20 })
const toQuery = (queryParams) => {
  if (!queryParams) return '';
  if (typeof queryParams === 'string') return queryParams;
  const params = new URLSearchParams();
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.append(key, value);
  });
  const str = params.toString();
  return str ? `?${str}` : '';
};

// All campaigns of a branch, each with its summary
// queryParams: page, limit, search, from (YYYY-MM-DD), to (YYYY-MM-DD)
export const fetchAllWhatsappCampaigns = async (branchId, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/whatsappcampaign/getAllCampaigns/${branchId}${toQuery(queryParams)}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();
  return resData;
};

// One campaign: summary + failure reasons + every client (name, number, status, readAt)
// queryParams: page, limit, status (read | delivered | sent | submitted | failed | notRead), search
export const fetchWhatsappCampaignDetails = async (branchId, batchId, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/whatsappcampaign/getCampaignDetails/${branchId}/${batchId}${toQuery(queryParams)}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();
  return resData;
};